module.exports = __webpack_public_path__ + "static/tatianawork1-028d8511329e3c1f4d54f20652e3e1fe.jpeg";